export const MITRE_TACTIC_LIST_SET = 'MITRE_TACTIC_LIST_SET'
export const MITRE_TACTIC_LIST_REQ = 'MITRE_TACTIC_LIST_REQ'
export const MITRE_TACTIC_LIST_SUCCESS = 'MITRE_TACTIC_LIST_SUCCESS'
export const MITRE_TACTIC_LIST_ERROR = 'RULES_TACTIC_LIST_ERROR'

export const MITRE_TECHNIQUE_LIST_SET = 'MITRE_TECHNIQUE_LIST_SET'
export const MITRE_TECHNIQUE_LIST_REQ = 'MITRE_TECHNIQUE_LIST_REQ'
export const MITRE_TECHNIQUE_LIST_SUCCESS = 'MITRE_TECHNIQUE_LIST_SUCCESS'
export const MITRE_TECHNIQUE_LIST_ERROR = 'RULES_TECHNIQUE_LIST_ERROR'

export const MITRE_COVERAGE_SET = 'MITRE_COVERAGE_SET'



// WEBPACK FOOTER //
// ./src/store/modules/mitre-attack/mitre-attack.type.js